/**
 * Shared constants for the legal surface (#126, FR-13.1). Kept in one module so the
 * binding entity and the support contact are a single-edit source of truth across the
 * Terms / Privacy / Refund pages and the footer.
 *
 * The pre-launch draft marker and placeholder mailing address (#126 scaffolding) were
 * dropped at launch finalization (#135, owner self-review): the pages now stand as the
 * live policies, and the support email below is the single contact channel.
 */

/** The binding operating entity named in all three documents (issue #126, decision 1). */
export const LEGAL_ENTITY = 'Nance Technologies LLC';

/**
 * Support/contact address (#115). Surfaced as a `mailto:` on every legal page and the
 * sole contact channel for privacy/data-rights requests; a full feedback channel is #40.
 */
export const LEGAL_CONTACT_EMAIL = 'support@nance.games';
